import React from 'react';
import Drawer from 'material-ui/Drawer';

export default ({ drawerItems, open, toggleDrawer }) => (
  <Drawer open={open} docked={false} onRequestChange={toggleDrawer}>
    {drawerItems}
  </Drawer>
);



// WEBPACK FOOTER //
// ./src/components/navbar/Drawer.js